import React from 'react';
import LogInButton from '@/finsight/ui/common/components/LogInButton';

import styles from './styles.scss';

const TopCompaniesNoAccessFrame = () => {
  return (
    <div className={ styles.container }>
      <div className={ styles.title }>View League Tables</div>
      <div className={ styles.description }>
        To view dynamic league tables of the top Issuers, Rating Agencies and Underwriters,
        please log in or create a free Finsight.com account.
      </div>
      <LogInButton dataTest="marketOverviewTopIssuersLoginButton" withIcon={ false } variant="outline" />
    </div>
  );
};

export default TopCompaniesNoAccessFrame;
